
import LayoutContent from '../../components/layouts/content2';
import React, {useState, useEffect} from 'react';

import {useTranslation} from 'react-i18next';
import { getData } from '../../helpers/indexedDbHelper';
import SpecialsScreen from './specials';
import { useRefresh } from '../../hooks/useRefresh';
import ListProducts from './ListProducts';
import BeerScreen from './beer'
import CategoriesScreen from './categories';
// import MargaritasScreen from './margaritas.js'
// import WinesScreen from './wines.js'
// import SpiritsScreen from './spirits.js'
// import BottlesScreen from './bottles.js'

function Index({setShowHappy}) { 

    const {i18n} = useTranslation();

        const {change} = useRefresh();
    
     const [menus, setMenus] = useState([]);

    const [showSpecials, setShowSpecials] = useState(false);
    const [showCoctatik, setshowCoctatik] = useState(false);
    const [showBeers, setshowBeers] = useState(false);
     const [showCategories, setshowCategories] = useState(false);
     const [showListProduct, setShowListProduct] = useState(false);
     const [dishs, setdishs] = useState(false);
    const [beers, setbeers] = useState(false);
    const [coladas, setcoladas] = useState(false);
    const [martinis, setmartinis] = useState(false);
    const [sangria, setsangria] = useState(false);
      const [noalcol, setnoalcol] = useState(false);

        
    useEffect(() => {
        getData('menu').then((items) => {
            // Sin menu en disco todavia: no reventar la app entera.
            if (!items?.value?.data) return;
            const data = items.value.data;
            
            setMenus(data);
        });
    }, [change]);


      useEffect(() => {
            menus.map((item) => {
            if (item.id === 565) {
                setshowCoctatik(item);
            }
                 if (item.id === 564) {
                setbeers(item);
            }
           
            });
      }, [menus]);
    
    
    
    return (
        <div style={{position: 'absolute', top: 0, left: 0, width: '100%', height: '100%', zIndex: 9999}}>
            <LayoutContent  goCategories={setshowCategories} showBack={true} setShowSpecials={setShowSpecials} setShowListProduct={setShowHappy}>
                <div  style={{padding: '0 20px', height: 750,  overflow: 'scroll'}}>
                    
                    <img src={require('./assets/67eab0b7e432f.png')} style={{ width: '100%', height: 340, objectFit: 'contain', borderRadius: 20 }} />
                    <br />
                    <br />
                    <h2
        style={{
          textTransform: "uppercase",
          fontSize: "24px",
          fontWeight: "bold",
          color: "#ffffff",
          margin: 0,
        }}
      >
        Add{" "}
        <span style={{ color: "#fbbf24" /* amarillo */ }}>
          Your Favorite Liquor
        </span>{" "}
        to your
      </h2>
      <h2
        style={{
          textTransform: "uppercase",
          fontSize: "28px",
          fontWeight: "bold",
          color: "#ffffff",
          marginTop: "10px",
        }}
      >
        Margarita
      </h2>
                    <img src={require('./assets/textmargarita.png')} style={{width: '100%', height: 600, objectFit: 'contain', borderRadius: 20}} />
                           
                    
                  
                </div>
                                        
                {showListProduct && <ListProducts
                    dishs={dishs}
                    setShowListProduct={setShowListProduct}
                />}

                {showBeers && <BeerScreen setShowHappy={setshowBeers} />}
                
                {/* 
                {showMargaritas && <MargaritasScreen setShowHappy={setshowMargaritas} />}
                {showWines && <WinesScreen setShowHappy={setshowWines} />}
                {showSpirits && <SpiritsScreen setShowHappy={setShowSpirits} />}
                {showBottles && <BottlesScreen setShowHappy={setshowBottles} />} */}
                
                     {showCategories && <CategoriesScreen setshowCategories={setshowCategories} />}
                
                {showSpecials && <SpecialsScreen setShowListProduct={setShowSpecials} setShowHappy={setShowHappy} />}
            </LayoutContent>
        </div>
    );
}
export default Index;